import {OrderService, MovieService, RegionService, ErrorDescriptionService} from 'hasta-la-vista-middleware-api/service'
export default {

    // props: {
    // 	step: Number
    // },

    name: 'BookingUnsuccessful',

    data() {
        return {
            loading: true,
            booking: OrderService.getBookings(),
            error: undefined,
            order: undefined,
            related_movies: [],
        }
    },


    methods: {
        returnToBookingFlow() {

            if (this.order.Tickets.length > 0)
                this.$router.push('/booking/4');
            else (OrderService.restartOrder().then(()=> {
                this.$router.push('/booking/1');
            }))
        }
    },
    created(){

        try {
            OrderService.getOrder().then((order)=> {
                this.loading = false;
                this.order = order;
            }, (e)=> {
                this.loading = false;
            });
        }catch (e){
            this.loading = false;
        }


    }
}


// WEBPACK FOOTER //
// ./src/components/booking/booking-unsuccessful/booking-unsuccessful.js